import type { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/_lib/utils'

export const Container = ({ children, className, ...rest }: ComponentPropsWithoutRef<'div'>) => {
  return (
    <div
      className={cn('flex h-full flex-col items-center bg-brand-grayscale-1 p-6', className)}
      {...rest}
    >
      {children}
    </div>
  )
}
